module.exports = __webpack_public_path__ + "img/facebook-logo.e31fbba9.svg";